import React, { Fragment, useEffect, useState } from 'react'
import Header from './Header'

//icons
import { FaUserPlus } from "react-icons/fa";
import { FiEdit } from "react-icons/fi";
import { MdOutlineDelete } from "react-icons/md";
import { MdClose } from "react-icons/md";
import axios from 'axios';
import { API } from './constant';
import { IoMdClose } from 'react-icons/io';



const Users = () => {
  const [showModal, setshowModal] = useState(false)
  const [updateTable, setupdateTable] = useState(false)


  //============= ============find user role and give permission start ============================
  const [loggedinRole, setLoggedinRole] = useState("")
  const [loggedinLocation, setLoggedinLocation] = useState("")
  // console.log(loggedinLocation)
  useEffect(() => {
    axios.get(`${API}/login/logged-in-user`, {
      headers: {
        "Content-Type": "application/json",
        "token": localStorage.getItem("token")
      }
    })
      .then((res) => {
        // console.log(res.data.data.school_location)
        setLoggedinRole(res.data.data.role)
        setLoggedinLocation(res.data.data.school_location)
      })
      .catch((err) => {
        // console.log(err);
        if (err.response) {
          // Handle invalid token
          if (err.response.status === 401) {
            localStorage.removeItem("token");
            // history.push('/');
            window.location.href = "/"
          }
          // Handle token expiration
          else if (err.response.status === 302) {
            window.location.href = "/"

          }
        }
      });
  }, [])

  //============= ============find user role and give permission end ============================


  // const class_section = [
  //   {
  //     class_name: "one",
  //     section: [
  //       "A",
  //       "B",
  //       "C",
  //     ]
  //   },
  //   {
  //     class_name: "Two",
  //     section: [
  //       "A",
  //       "B",
  //       "C",
  //       "D",
  //       "E"
  //     ]
  //   },
  //   {
  //     class_name: "Three",
  //     section: [
  //       "A",
  //       "B",
  //       "C",
  //       "D",
  //       "E",
  //       "F",
  //       "G",
  //       "H",
  //     ]
  //   }
  // ]

  //===================== operation on  user start =======================


  // ===================operation on search data start ====================
  const [searchLocation, setsearchLocation] = useState("")
  const [searchName, setsearchName] = useState("")
  const [searchEmail, setsearchEmail] = useState("")
  const [searchStatus, setsearchStatus] = useState("")
  // ===================operation on search data end ====================

  // ----------create user start ------------------
  const [userName, setuserName] = useState("")
  const [schoolLocation, setschoolLocation] = useState(`${loggedinLocation}`)
  // console.log(schoolLocation)
  const [userEmail, setuserEmail] = useState("")
  const [userPassword, setuserPassword] = useState("")
  const [userRole, setuserRole] = useState("")


  // fetch all users data from the api start 
  const [allData, setAllData] = useState([]);
  const [permissions, setPermissions] = useState({});
  const [class_section, setclass_section] = useState([])
  // console.log(permissions)

  // console.log(class_section)
  // useEffect(() => {
  //   axios.get(`${API}/upload`)
  //     .then((res) => {
  //       console.log(res.data.data)
  //       const fetchedData = res.data.data;
  //       setAllData(fetchedData);
  //       processPermissionsData(fetchedData);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // }, [updateTable]);


  // ========================new working of the application start ===================================
  useEffect(() => {
    axios.get(`${API}/create-section`, {
      headers: {
        "Content-Type": "application/json",
        "token": localStorage.getItem("token")
      }
    })
      .then((res) => {
        // console.log(res.data.data);
        const fetchedData = res.data.data;

        // Process the new data model to match the existing structure
        const processedPermissions = fetchedData.reduce((acc, item) => {
          acc[item.class_name] = item.sections.reduce((sectionsAcc, section) => {
            sectionsAcc[section] = false; // Initialize all sections as unchecked
            return sectionsAcc;
          }, {});
          return acc;
        }, {});

        setAllData(fetchedData);  // If needed for other purposes
        setPermissions(processedPermissions); // Set the permissions state
      })
      .catch((err) => {
        console.log(err);
      });
  }, [updateTable]);



  // ========================new working of the application end ===================================

  // ----------get all school location start -----------
  const [allLocationData, setallLocationData] = useState([])
  useEffect(() => {
    axios.get(`${API}/school-location`)
      .then((res) => {
        // console.log(res)
        setallLocationData(res.data.data)
      })
      .catch((err) => {
        console.log(err)
      })
  }, [updateTable])
  // ----------get all school location end-----------



  const processPermissionsData = (data) => {
    const processedData = {};
    data.forEach(item => {
      if (!processedData[item.class]) {
        processedData[item.class] = {};
      }
      if (!processedData[item.class][item.section]) {
        processedData[item.class][item.section] = false;
      }
    });
    setPermissions(processedData);

  };

  const handlePermissionChange = (className, section, isChecked) => {
    setPermissions(prevPermissions => ({
      ...prevPermissions,
      [className]: {
        ...prevPermissions[className],
        [section]: isChecked
      }
    }));
  };
  // fetch all users data from the api end


  const handleSchoolLocationChange = (e) => {
    setschoolLocation(e.target.value);
  };



  const submitUser = async () => {
    const data = {
      name: userName,
      school_location: loggedinRole === "Super Admin" ? schoolLocation : loggedinLocation,
      email: userEmail,
      password: userPassword,
      role: userRole,
      permissions: Object.keys(permissions).map(className => ({
        class_name: className,
        sections: Object.keys(permissions[className]).filter(section => permissions[className][section])
      }))
    }
    await axios.post(`${API}/register`, data, {
      headers: {
        "Content-Type": "application/json",
        "token": localStorage.getItem("token")
      }
    })
      .then((res) => {
        // console.log(res)
        alert(res.data.message)
        clearfields()
        setshowModal(false)
        setupdateTable(!updateTable)
      })
      .catch((err) => {
        // console.log(err)
        alert(err.response.data.message)
      })
  }
  // ----------create user end ------------------

  // -------get user start -------------
  const [getAllUser, setgetAllUser] = useState([])
  useEffect(() => {
    axios.get(`${API}/register`, {
      headers: {
        "Content-Type": "application/json",
        "token": localStorage.getItem("token")
      }
    })
      .then((res) => {
        // console.log(res.data.data)
        setgetAllUser(res.data.data)
      })
      .catch((err) => {
        console.log(err)
      })
  }, [updateTable])
  // -------get user end -------------

  // ------------------edit user start ----------------
  const [editShowModal, seteditShowModal] = useState(false)
  const [selectedRow, setselectedRow] = useState(null)
  const [checkedPermission, setcheckedPermission] = useState({})
  // console.log(checkedPermission)

  // const class_section = [
  //   { class_name: "one", section: ["A", "B", "C"] },
  //   { class_name: "Two", section: ["A", "B", "C", "D", "E"] },
  //   { class_name: "Three", section: ["A", "B", "C", "D", "E", "F", "G", "H"] }
  // ];



  // const handleEditUser = (rowData) => {
  //   setselectedRow(rowData)
  //   seteditShowModal(true)

  //   const userPermissions = rowData.permissions.reduce((acc, curr) => {
  //     acc[curr.class_name] = curr.sections.reduce((sectionsAcc, section) => {
  //       sectionsAcc[section] = true;
  //       return sectionsAcc;
  //     }, {});
  //     return acc;
  //   }, {});
  //   // setPermissions(userPermissions);
  //   setclass_section(userPermissions)
  // }


  const handleEditUser = (rowData) => {
    setselectedRow(rowData);
    seteditShowModal(true);

    const userPermissions = rowData.permissions.reduce((acc, curr) => {
      acc[curr.class_name] = curr.sections.reduce((sectionsAcc, section) => {
        sectionsAcc[section] = true;
        return sectionsAcc;
      }, {});
      return acc;
    }, {});
    setcheckedPermission(userPermissions);
  };


  const handleeditPermissionChange = (className, section, isChecked) => {
    setcheckedPermission((prevPermissions) => ({
      ...prevPermissions,
      [className]: {
        ...prevPermissions[className],
        [section]: isChecked,
      },
    }));

    setselectedRow((prev) => {
      const existingClass = prev.permissions.find((perm) => perm.class_name === className);
      let updatedPermissions;

      if (existingClass) {
        updatedPermissions = prev.permissions.map((perm) =>
          perm.class_name === className
            ? {
              ...perm,
              sections: isChecked
                ? [...perm.sections, section]
                : perm.sections.filter((sec) => sec !== section),
            }
            : perm
        );
      } else {
        updatedPermissions = [
          ...prev.permissions,
          { class_name: className, sections: [section] }
        ];
      }

      return {
        ...prev,
        permissions: updatedPermissions,
      };
    });
  };

  // const handleUpdateUser = async (id) => {

  //   // Update the data state with the edited row data
  //   setgetAllUser((prevData) =>
  //     prevData.map((item) => (item._id === selectedRow._id ? selectedRow : item)))

  //   // Send the updated data to the server (assuming an API endpoint exists)
  //   await axios.put(`${API}/register/${selectedRow._id}`, selectedRow)
  //     .then((res) => {
  //       console.log(res)
  //     })
  //     .catch((err) => {
  //       console.log(err)
  //     })


  // }

  const handleUpdateUser = async (id) => {
    const updatedUser = {
      ...selectedRow,
      permissions: Object.keys(checkedPermission).map((className) => ({
        class_name: className,
        sections: Object.keys(checkedPermission[className]).filter((section) => checkedPermission[className][section]),
      })),
    };

    // Update the data state with the edited row data
    setgetAllUser((prevData) =>
      prevData.map((item) => (item._id === selectedRow._id ? updatedUser : item))
    );

    // Send the updated data to the server (assuming an API endpoint exists)
    await axios
      .put(`${API}/register/${selectedRow._id}`, updatedUser, {
        headers: {
          "Content-Type": "application/json",
          "token": localStorage.getItem("token")
        }
      })
      .then((res) => {
        console.log(res.data.message);
        alert(res.data.message)
        setupdateTable(!updateTable)
      })
      .catch((err) => {
        console.log(err);
      });

    seteditShowModal(false); // Close the modal after updating
  };



  //------------------ edit user end----------------------

  //===================== operation on  user end =======================



  // delete user start 
  const [deletePopUp, setdeletePopUp] = useState(false)
  const [DeleteId, setDeleteId] = useState("")

  const handleDeleteUser = (id) => {
    setdeletePopUp(true)
    setDeleteId(id)
  }

  const handleDelete = async (id) => {
    await axios.delete(`${API}/register/${id}`, {
      headers: {
        "Content-Type": "application/json",
        "token": localStorage.getItem("token")
      }
    })
      .then((res) => {
        console.log(res)
        setdeletePopUp(false)
        setupdateTable(!updateTable)
      })
      .catch((err) => {
        console.log(err)
      })
  }
  // delete user end




  // ===========================check all and clear all functionality start ================================
  // --------for updating user start -------------

  const [checkAll, setCheckAll] = useState(true);
  const handleCheckAllPermissions = () => {
    const newCheckedPermissions = {};

    Object.keys(permissions).forEach((className) => {
      newCheckedPermissions[className] = {};
      Object.keys(permissions[className]).forEach((section) => {
        newCheckedPermissions[className][section] = checkAll;
      });
    });

    setcheckedPermission(newCheckedPermissions);
    setCheckAll(!checkAll);
  };
  // --------for updating user end -------------

  // -------for creating the user start ------------
  const [checkAllCreate, setCheckAllCreate] = useState(true);

  const handleCheckAllCreatePermissions = () => {
    const newCheckedPermissions = {};

    Object.keys(permissions).forEach((className) => {
      newCheckedPermissions[className] = {};
      Object.keys(permissions[className]).forEach((section) => {
        newCheckedPermissions[className][section] = checkAllCreate;
      });
    });

    setPermissions(newCheckedPermissions);
    setCheckAllCreate(!checkAllCreate);
  };
  // ----------for creating the user end --------------

  // ===========================check all and clear all functionality end ================================


  // ===========================reset password modal start ================================
  const [resetModal, setresetModal] = useState(false)
  const [resetModalIdOfData, setresetModalIdOfData] = useState("")

  const handleResetModal = async (id) => {
    setresetModalIdOfData(id)
    setresetModal(true)
  }

  const handleUpdatePassword = async (id) => {
    const data = {
      password: selectedRow.password
    }
    await axios.patch(`${API}/register/reset-password/${selectedRow._id}`, data, {
      headers: {
        "Content-Type": "application/json",
        "token": localStorage.getItem("token")
      }
    })
      .then((res) => {
        // console.log(res.data)
        alert(res.data.message)
        setresetModal(false)
        setupdateTable(!updateTable)
      })
      .catch((err) => {
        console.log(err)
        alert(err.response.data.message)
      })
  }
  // ===========================reset password modal end ================================



  // ===========const clear fields start =====================
  function clearfields() {
    setuserName("")
    setschoolLocation("")
    setuserEmail("")
    setuserPassword("")
    setuserRole("")
  }
  // ===========const clear fields end =====================

  // console.log(loggedinRole)
  // console.log(loggedinRole !== "Super Admin")


  return (
    <div>
      {
        loggedinRole && loggedinRole === "Admin" || loggedinRole === "Super Admin" ? (

          <div>
            <Header />
            <div className='flex justify-center mt-[70px] sm:mt-[150px]'>
              <div className='max-w-[1500px] w-full  ' >
                <div className='flex flex-wrap justify-between'>
                  <div className='flex flex-wrap gap-2 sm:gap-8'>
                    <div className='w-[45%] sm:w-auto'>
                      <div >
                        <h2 className='text-[12px] sm:text-[15px]'>Location:</h2>
                        <select disabled={loggedinRole !== "Super Admin"} value={loggedinRole === "Super Admin" ? `${searchLocation}` : `${loggedinLocation}`} onChange={(e) => setsearchLocation(e.target.value)} className='text-[12px] sm:text-[15px] bg-black outline-none w-full text-white'>
                          <option value="">Select School Location</option>
                          {
                            allLocationData && allLocationData.map((item, index) => {
                              return (
                                <option value={item.name}>{item.name}</option>
                              )
                            })
                          }
                        </select>
                      </div>
                    </div>

                    <div className='w-[45%] sm:w-auto'>
                      <div>
                        <h2 className='text-[12px] sm:text-[15px]'>Search Name:</h2>
                      </div>
                      <input value={searchName} onChange={(e) => setsearchName(e.target.value)} type="search" className='text-[12px] sm:text-[15px] bg-black outline-none w-full text-white px-[10px]' placeholder='Search Name' />
                    </div>
                    <div className='w-[45%] sm:w-auto'>
                      <div>
                        <h2 className='text-[12px] sm:text-[15px]'>Email:</h2>
                      </div>
                      <input value={searchEmail} onChange={(e) => setsearchEmail(e.target.value)} type="search" className='text-[12px] sm:text-[15px] bg-black outline-none w-full text-white px-[10px]' placeholder='Search Email' />
                    </div>
                    <div className='w-[45%] sm:w-auto'>
                      <div>
                        <h2 className='text-[12px] sm:text-[15px]'>Status:</h2>
                      </div>
                      <select value={searchStatus} onChange={(e) => setsearchStatus(e.target.value)} className='text-[12px] sm:text-[15px] bg-black outline-none w-full text-white'>
                        <option value="">Select Status</option>
                        <option value="Active">Active</option>
                        <option value="Inactive">Inactive</option>
                      </select>
                    </div>
                  </div>
                  <div onClick={() => setshowModal(true)} className='mt-[10px] bg-[#1B1B1B] text-white px-[10px] py-[10px] sm:px-[20px] sm:py-[10px] font-semibold text-[12px] sm:text-[15px] rounded-md flex items-center gap-3 cursor-pointer'>
                    <FaUserPlus size={20} /> <h3>Create User</h3>
                  </div>
                </div>
                <div className='mt-[20px] w-full overflow-auto max-h-[70vh]' >
                  <table className='w-full border-collapse '>
                    <thead className=''>
                      <tr className='text-[12px] sm:text-[15px]   border-collapse bg-[#8321A8] text-white'>
                        <th className='border-[1px] border-black border-collapse sticky top-0  bg-[#8321A8]'>#</th>
                        <th className='border-[1px] border-black border-collapse sticky top-0  bg-[#8321A8]'>User Name</th>
                        <th className='border-[1px] border-black border-collapse sticky top-0  bg-[#8321A8]'>School Location</th>
                        <th className='border-[1px] border-black border-collapse sticky top-0  bg-[#8321A8]'>Email</th>
                        <th className='border-[1px] border-black border-collapse sticky top-0  bg-[#8321A8]'>Role</th>
                        {
                          loggedinRole === "Super Admin" || loggedinRole === "Admin" ? <th className='border-[1px] border-black border-collapse sticky top-0  bg-[#8321A8]'>Status</th> : null
                        }
                        <th className='border-[1px] border-black border-collapse sticky top-0  bg-[#8321A8]'>Update</th>
                        <th className='border-[1px] border-black border-collapse sticky top-0  bg-[#8321A8]'>Delete</th>
                      </tr>
                    </thead>
                    <tbody className='w-full'>
                      {
                        getAllUser && getAllUser
                          .filter((item) => {
                            // If loggedinRole is "Super Admin", filter by searchLocation or show all
                            if (loggedinRole === "Super Admin") {
                              return !searchLocation || item.school_location === searchLocation;
                            }
                            // Otherwise, filter by loggedinLocation
                            return item.school_location === loggedinLocation;
                          })
                          .filter((item) => {
                            // Further filter by searchName if provided
                            return !searchName || item.name.toLowerCase().includes(searchName.toLowerCase());
                          })
                          .filter((item) => {
                            // Further filter by searchEmail if provided
                            return !searchEmail || item.email.toLowerCase().includes(searchEmail.toLowerCase());
                          })
                          .filter((item) => {
                            // Further filter by searchStatus if provided
                            if (!searchStatus) return true; // If no status filter, include all
                            if (searchStatus === "Active") return item.active === true;
                            if (searchStatus === "Inactive") return item.active === false;
                            return true;
                          })
                          .map((item, index) => {
                            return (
                              <tr key={index} className='text-[12px] sm:text-[15px] border-[1px] border-black  border-collapse hover:bg-[#EEA3F7]'>
                                <td className='border-[1px] border-black border-collapse text-center align-middle'>{index + 1}</td>
                                <td className='border-[1px] border-black border-collapse text-center align-middle'>{item.name}</td>
                                <td className='border-[1px] border-black border-collapse text-center align-middle'>{item.school_location}</td>
                                <td className='border-[1px] border-black border-collapse text-center align-middle'>{item.email}</td>
                                <td className='border-[1px] border-black border-collapse text-center align-middle'>{item.role}</td>
                                {
                                  loggedinRole === "Super Admin" || loggedinRole === "Admin" ? (
                                    <td className='border-[1px] border-black border-collapse text-center align-middle'>
                                      {item.active ? "Active" : "Inactive"}
                                    </td>
                                  ) : null
                                }
                                <td className='border-[1px] border-black border-collapse text-center align-middle'><FiEdit size={20} onClick={() => handleEditUser(item)} /></td>
                                <td className='border-[1px] border-black border-collapse text-center align-middle'><MdOutlineDelete onClick={() => handleDeleteUser(item._id)} size={25} /></td>
                              </tr>
                            )
                          })
                      }

                      {/* <tr className='border-[1px] border-black  border-collapse hover:bg-[#EEA3F7]'>
                      <td className='border-[1px] border-black border-collapse text-center align-middle'>1.</td>
                      <td className='border-[1px] border-black border-collapse text-center align-middle'>Neeeraj</td>
                      <td className='border-[1px] border-black border-collapse text-center align-middle'>4</td>
                      <td className='border-[1px] border-black border-collapse text-center align-middle'>a</td>
                      <td className='border-[1px] border-black border-collapse text-center align-middle'><FiEdit size={20} /></td>
                      <td className='border-[1px] border-black border-collapse text-center align-middle'><MdOutlineDelete size={25} /></td>
                    </tr> */}

                    </tbody>
                  </table>
                </div>

                {
                  showModal && showModal ? (
                    <div>
                      <div className='fixed inset-0 flex justify-center items-center bg-black/70'>
                        <div className=' w-[500px] bg-white'>
                          <div className='bg-[#8321A8] text-white flex justify-between items-center px-[10px]'>
                            <div> <h1 className='text-[30px] '>Create User</h1></div>
                            <div ><MdClose onClick={() => setshowModal(false)} size={35} /></div>
                          </div>
                          <div>
                            <div className='flex'>
                              <div className='px-[20px] mt-[10px] w-[50%]'>
                                <div className='text-[18px]'>
                                  <label htmlFor="">Name:</label>
                                </div>
                                <div>
                                  <input value={userName} onChange={(e) => setuserName(e.target.value)} className='bg-black px-[10px] py-[5px] rounded-md text-white w-full outline-none' type="text" placeholder='Name' />
                                </div>

                              </div>
                              <div className='px-[20px] mt-[10px] w-[50%]'>
                                <div className='text-[18px]'>
                                  <label htmlFor="">School Location:</label>
                                </div>
                                <div>
                                  <select disabled={loggedinRole !== "Super Admin"} value={loggedinRole === "Super Admin" ? `${schoolLocation}` : `${loggedinLocation}`} onChange={(e) => handleSchoolLocationChange(e)} className='bg-black px-[10px] py-[5px] rounded-md text-white w-full outline-none'>
                                    {/* <select   value={schoolLocation} onChange={(e) => handleSchoolLocationChange(e)} className='bg-black px-[10px] py-[5px] rounded-md text-white w-full outline-none'> */}
                                    <option value="">Select School Location</option>
                                    {
                                      allLocationData && allLocationData.map((item, index) => {
                                        return (
                                          <option value={item.name}>{item.name}</option>
                                        )
                                      })
                                    }
                                    {/* <option value="Kanpur">Kanpur</option>
                                  <option value="Ghaziabad">Ghaziabad</option> */}
                                  </select>
                                </div>

                              </div>
                              <div></div>
                            </div>

                            <div className='flex'>
                              <div className='px-[20px] mt-[10px] w-[50%]'>
                                <div className='text-[18px]'>
                                  <label htmlFor="">Email:</label>
                                </div>
                                <div>
                                  <input value={userEmail} onChange={(e) => setuserEmail(e.target.value)} className='bg-black px-[10px] py-[5px] rounded-md text-white w-full outline-none' type="text" placeholder='Email' />
                                </div>

                              </div>
                              <div className='px-[20px] mt-[10px] w-[50%]'>
                                <div className='text-[18px]'>
                                  <label htmlFor="">Password:</label>
                                </div>
                                <div>
                                  <input value={userPassword} onChange={(e) => setuserPassword(e.target.value)} className='bg-black px-[10px] py-[5px] rounded-md text-white w-full outline-none' type="password" placeholder='Password' />
                                </div>

                              </div>
                              <div></div>
                            </div>

                            <div className='flex'>
                              <div className='px-[20px] mt-[10px] w-full'>
                                <div className='text-[18px]'>
                                  <label htmlFor="">Role:</label>
                                </div>
                                <div>
                                  <select value={userRole} onChange={(e) => setuserRole(e.target.value)} className='bg-black px-[10px] py-[5px] rounded-md text-white w-full outline-none'>
                                    <option value="">Select User Role</option>
                                    <option value="Admin">Admin</option>
                                    <option value="Teacher">Teacher</option>
                                    {
                                      loggedinRole === "Super Admin" ? <option value="Super Admin">Super Admin</option> : null
                                    }
                                    {/* <option className={`${loggedinRole?.loggedinRole==="Super Admin"?"hidden":null}`}  value="Super Admin">Super Admin</option> */}
                                  </select>
                                </div>
                              </div>
                            </div>

                            <div className=''>

                              {/* <div className='text-[18px] px-[20px] mt-[10px] w-full'>
                              <div>
                                Permissions:
                              </div>
  
                              <div className='h-[20vh] overflow-hidden overflow-y-scroll bg-[#eea3f7] px-[10px]'>
                                {
                                  class_section && class_section.map((item, index) => {
                                    return (
                                      <div key={index}>
                                        <h3>Class {item.class_name}</h3>
                                        <div className='flex items-center justify-start gap-3 px-[10px]' key={index}>
                                          {
                                            item.section.map((sec_item, index) => {
                                              return (
                                                <Fragment key={index}>
                                                  <div>
                                                    <input type="checkbox" value={sec_item[0]} /><label htmlFor="">{sec_item[0]}</label>
                                                  </div>
                                                </Fragment>
                                              )
                                            })
                                          }
                                        </div>
  
                                      </div>
                                    )
                                  })
                                }
  
                              </div>
                            </div> */}

                              <div className='text-[18px] px-[20px] mt-[10px] w-full'>
                                <div className='flex justify-between items-center my-[10px]'>
                                  <h1>
                                    Permissions:
                                  </h1>
                                  <button
                                    onClick={handleCheckAllCreatePermissions}
                                    className={`${checkAll ? "bg-green-600" : "bg-red-600"} text-white px-[10px] py-[5px] font-semibold text-[15px] rounded-md`}

                                  >
                                    {checkAllCreate ? "Check All" : "Clear All"}
                                  </button>
                                </div>
                                <div className='h-[20vh] overflow-hidden overflow-y-scroll bg-[#eea3f7] px-[10px]'>
                                  {allData && Object.keys(permissions).map((className, index) => (
                                    <div key={index}>
                                      <h3>{className}</h3>
                                      <div className='flex items-center justify-start gap-3 px-[10px]'>
                                        {Object.keys(permissions[className]).map((section, secIndex) => (
                                          <Fragment key={secIndex}>
                                            <div>
                                              <input
                                                type="checkbox"
                                                checked={permissions[className][section]}
                                                onChange={(e) => handlePermissionChange(className, section, e.target.checked)}
                                              />
                                              <label htmlFor="">{section}</label>
                                            </div>
                                          </Fragment>
                                        ))}
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </div>


                            </div>

                            <div className='flex justify-center my-[10px]'>
                              <button onClick={submitUser} className='bg-[#1B1B1B] text-white px-[20px] py-[5px] font-semibold text-[15px] rounded-md'>Add</button>
                            </div>
                          </div>

                        </div>

                      </div>
                    </div>
                  ) : null
                }



                {
                  editShowModal && editShowModal ? (
                    <div>
                      <div className='fixed inset-0 flex justify-center items-center bg-black/70'>
                        <div className=' w-[500px] bg-white'>
                          <div className='bg-[#8321A8] text-white flex justify-between items-center px-[10px]'>
                            <div> <h1 className='text-[30px] '>Edit User</h1></div>
                            <div ><MdClose onClick={() => seteditShowModal(false)} size={35} /></div>
                          </div>
                          <div>
                            <div className='flex'>
                              <div className='px-[20px] mt-[10px] w-[50%]'>
                                <div className='text-[18px]'>
                                  <label htmlFor="">Name:</label>
                                </div>
                                <div>
                                  <input value={selectedRow?.name} onChange={(e) => setselectedRow((prev) => ({ ...prev, name: e.target.value }))} className='bg-black px-[10px] py-[5px] rounded-md text-white w-full outline-none' type="text" placeholder='Name' />
                                </div>

                              </div>

                              <div className='px-[20px] mt-[10px] w-[50%]'>
                                <div className='text-[18px]'>
                                  <label htmlFor="">School Location:</label>
                                </div>
                                <div>
                                  <select disabled={loggedinRole !== "Super Admin"} value={selectedRow?.school_location} onChange={(e) => setselectedRow((prev) => ({ ...prev, school_location: e.target.value }))} className='bg-black px-[10px] py-[5px] rounded-md text-white w-full outline-none'>
                                    <option value="">Select School Location</option>
                                    {/* <option value="Lucknow">Lucknow</option>
                                  <option value="Kanpur">Kanpur</option>
                                  <option value="Ghaziabad">Ghaziabad</option> */}
                                    {
                                      allLocationData && allLocationData.map((item, index) => {
                                        return (
                                          <option value={item.name}>{item.name}</option>
                                        )
                                      })
                                    }
                                  </select>
                                </div>

                              </div>
                              <div></div>
                            </div>

                            <div className='flex'>
                              <div className='px-[20px] mt-[10px] w-[50%]'>
                                <div className='text-[18px]'>
                                  <label htmlFor="">Email:</label>
                                </div>
                                <div>
                                  <input value={selectedRow?.email} onChange={(e) => setselectedRow((prev) => ({ ...prev, email: e.target.value }))} className='bg-black px-[10px] py-[5px] rounded-md text-white w-full outline-none' type="text" placeholder='Email' />
                                </div>

                              </div>
                              {/* <div className='px-[20px] mt-[10px] w-[50%]'>
                              <div className='text-[18px]'>
                                <label htmlFor="">Password:</label>
                              </div>
                              <div>
                                <input value={selectedRow?.password} onChange={(e) => setselectedRow((prev) => ({ ...prev, password: e.target.value }))} className='bg-black px-[10px] py-[5px] rounded-md text-white w-full outline-none' type="password" placeholder='Password' />
                              </div>
  
                            </div> */}
                              <div className='px-[20px] mt-[10px] w-[50%]'>
                                <div className='text-[18px]'>
                                  <label htmlFor="">Role:</label>
                                </div>
                                <div>
                                  <select value={selectedRow?.role} onChange={(e) => setselectedRow((prev) => ({ ...prev, role: e.target.value }))} className='bg-black px-[10px] py-[5px] rounded-md text-white w-full outline-none'>
                                    <option value="">Select User Role</option>
                                    <option value="Admin">Admin</option>
                                    <option value="Teacher">Teacher</option>
                                    {
                                      loggedinRole === "Super Admin" ? <option value="Super Admin">Super Admin</option> : null
                                    }
                                  </select>
                                </div>
                              </div>
                              <div></div>
                            </div>

                            <div className='flex'>
                              {
                                loggedinRole === "Super Admin" || loggedinRole === "Admin" ? (
                                  <div className='px-[20px] mt-[10px] w-full'>
                                    <div className='text-[18px]'>
                                      <label htmlFor="">Status:</label>
                                    </div>
                                    <div>
                                      <select value={selectedRow?.active} onChange={(e) => setselectedRow((prev) => ({ ...prev, active: e.target.value }))} className='bg-black px-[10px] py-[5px] rounded-md text-white w-full outline-none'>
                                        <option value="">Select Status</option>
                                        <option value="true">Active</option>
                                        <option value="false">Inactive</option>
                                      </select>
                                    </div>
                                  </div>
                                ) : null
                              }

                            </div>

                            <div className=''>

                              <div className='text-[18px] px-[20px] mt-[10px] w-full'>
                                <div className='flex justify-between items-center my-[10px]'>
                                  <h1>
                                    Permissions:
                                  </h1>
                                  <button
                                    onClick={handleCheckAllPermissions}
                                    className={`${checkAll ? "bg-green-600" : "bg-red-600"} text-white px-[10px] py-[5px] font-semibold text-[15px] rounded-md`}
                                  >
                                    {checkAll ? "Check All" : "Clear All"}
                                  </button>
                                </div>

                                <div className='h-[20vh] overflow-hidden overflow-y-scroll bg-[#eea3f7] px-[10px]'>
                                  {allData && Object.keys(permissions).map((className, index) => (
                                    <div key={index}>
                                      <h3>{className}</h3>
                                      <div className='flex items-center justify-start gap-3 px-[10px]'>
                                        {Object.keys(permissions[className]).map((section, secIndex) => (
                                          <Fragment key={secIndex}>
                                            <div>
                                              <input
                                                type="checkbox"
                                                checked={checkedPermission[className]?.[section] || false}
                                                onChange={(e) => handleeditPermissionChange(className, section, e.target.checked)}
                                              />
                                              <label htmlFor="">{section}</label>
                                            </div>
                                          </Fragment>
                                        ))}
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </div>


                            </div>


                            {/* <div className='mt-[10px] px-[20px]'>
                            <h2 className='text-[18px] font-bold'>Permissions:</h2>
                            {class_section.map(classItem => (
                              <div key={classItem.class_name}>
                                <h3 className='text-[16px] font-semibold'>{classItem.class_name}</h3>
                                {classItem.section.map(section => (
                                  <div key={section} className='flex items-center'>
                                    <input
                                      type='checkbox'
                                      checked={permissions[classItem.class_name] ? permissions[classItem.class_name][section] : false}
                                      onChange={(e) => handlePermissionChange(classItem.class_name, section, e.target.checked)}
                                    />
                                    <label className='ml-[10px]'>{section}</label>
                                  </div>
                                ))}
                              </div>
                            ))}
                          </div> */}

                            <div className='flex justify-center gap-[10px] my-[10px]'>
                              <button onClick={() => handleUpdateUser(selectedRow?._id)} className='bg-[#1B1B1B] text-white px-[20px] py-[5px] font-semibold text-[15px] rounded-md'>Update</button>
                              <button onClick={() => handleResetModal(selectedRow?._id)} className='bg-green-600 text-white px-[20px] py-[5px] font-semibold text-[15px] rounded-md'>Reset Password</button>
                            </div>
                          </div>

                        </div>

                      </div>
                    </div>
                  ) : null
                }

                {
                  resetModal && resetModal ? (
                    <div className='inset-0 flex justify-center items-center fixed z-[50] bg-[#1c1d1f]/30' >
                      <div className='w-[350px]'>
                        <div className='bg-[#6C7AE0] py-[10px] px-[10px] flex justify-between'>
                          <h5 className='text-white text-[25px]'>Reset Password</h5>
                          <button onClick={() => setresetModal(false)}><IoMdClose size={30} color='white' /></button></div>
                        {/* input field block start */}
                        <div className='p-[10px] bg-white'>

                          <div className='p-[5px] flex justify-between'>
                            <div className='w-full'>
                              <label htmlFor="edit_school_location">Enter New Password:</label>
                              <input value={selectedRow?.password} onChange={(e) => setselectedRow((prev) => ({ ...prev, password: e.target.value }))} className='bg-black px-[10px] py-[5px] rounded-md text-white w-full outline-none' type="password" placeholder='Password' />

                            </div>

                          </div>
                          <div className=' p-[5px] flex justify-start my-[10px]'>
                            <button onClick={() => handleUpdatePassword(resetModalIdOfData)} className='hover:bg-[#6C7AE0] bg-[#121212] px-[15px] py-[5px] text-white rounded-md' >Update</button>
                          </div>

                        </div>
                        {/* input field block end */}
                      </div>
                    </div>
                  ) : null
                }


                {
                  deletePopUp && deletePopUp ? (
                    <div className='inset-0 flex justify-center items-center fixed z-[50] bg-[#1c1d1f]/30' >
                      <div className='w-[300px] bg-black rounded-md py-[20px]'>
                        <div>
                          <h4 className='text-[12px] text-white font-semibold text-center'>User will be Deleted permanently.</h4>
                        </div>



                        <div className='flex gap-6 justify-center my-[10px]'>

                          <button onClick={() => handleDelete(DeleteId)} className='bg-[#ec4848] px-[15px] py-[5px] text-white rounded-md' >Delete</button>
                          <button onClick={() => setdeletePopUp(false)} className='bg-[#1a5800] px-[15px] py-[5px] text-white rounded-md' >Cancel</button>
                        </div>
                      </div>

                    </div>
                  ) : null
                }
              </div>
            </div>
          </div>

        ) : (
          <>
            <p>You are not Authorized</p>
          </>
        )
      }


    </div>
  )
}

export default Users